import React from 'react'

const DataAutomation = () => {
    const serviceData = {
  hero: {
     heading: <>DATA & <br/> AUTOMATION</>,
  },
  section1: {
    description:
      <>Unlock Clarity, Accelerate Growth, Make Smarter Decisions.
Your business generates data every day — from sales, customers, operations, marketing, and employees. But without the right tools, this data stays scattered and unused.
We help you convert that data into clarity, control, and growth through world-class dashboards, automations, and custom business apps.
Below are the solutions we offer, designed to make your business more efficient, more informed, and more profitable.</>,
      title1: "Our Data & Automation Services",
    
    image: "/dataimg1.webp",
  points: [
      {
        head: "Power BI Dashboards – Real-Time Insights, Zero Guesswork",
        text: "Transform raw data into interactive dashboards for Google Ads, sales forecasting, customer behavior, finance, and operations. Get instant clarity on what’s working and where opportunities are being lost.",
      },
      {
        head: "Power Apps – Custom Business Apps That Replace Manual Work",
        text: "Digitize operations by replacing WhatsApp coordination, Excel tracking, and paper forms with custom apps for inventory, customer data entry, approvals, employee management, and on-field service.",
      },
      {
        head: "Power Automate – Automate Your Business & Save Hours Every Week",
        text: "Automate repetitive tasks like report generation, reminders, lead collection, data syncing, and team notifications. Reduce errors and free your team from manual work.",
      },
      {
        head: "Looker Studio – Make Digital Marketing Crystal Clear",
        text: "Get real-time dashboards for Google Ads, Meta Ads, and YouTube. Track conversions, ROI, CPL, campaign performance, and audience insights with fully automated reporting.",
      },
      {
        head: "Tableau Dashboards – Advanced Visual Analytics for Complex Data",
        text: "Ideal for large or multi-branch businesses requiring deep analytics. Includes trend forecasting, geographic mapping, profitability breakdowns, and executive-level insights.",
      },
    ],
  },
}
  return (
       <>

      <div className="services-hero">
        <div className='automation-hero-img'>
          <div className="overlay"></div>
          <div className="hero-content">
            <h2 className="hero_heading">{serviceData.hero.heading}</h2>
          
          </div>
        </div>
      </div>

      <div className="backdiv">
      
        <div className="servicepage_grid">
        <div>
  <p className='main_content'>{serviceData.section1.description}</p>
        </div>
          <div>
            <div className="servicepage_imgdiv">
              <img
                src={serviceData.section1.image}
                alt="Web Development"
                className="zweedo_img"
                loading="lazy"
              />
            </div>
          </div>

        </div>
          <div>
             <h2 className='main_heading'>{serviceData.section1.title1}</h2>
             
            <div className="servicepage_textdiv">
              {serviceData.section1.points.map((point, index) => (
                  <div key={index} className="service_point">
                    <h4 className="point_head">{point.head}</h4>
                    <p className="point_text">{point.text}</p>
                  </div>
                ))}
            </div>
          </div>
      </div>
    </>
  )
}

export default DataAutomation